import { useState, useEffect } from 'react';
import { AFFILIATE_URL, affiliateLinkProps, getAffiliateLinkProps } from '../../../constants/affiliate';
import { trackRegisterClick } from '../../../utils/analytics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'About iPAY9', href: AFFILIATE_URL, source: 'navbar_nav_about_ipay9' },
    { label: 'Mobile App', href: AFFILIATE_URL, source: 'navbar_nav_mobile_app' },
    { label: 'Sports Bet', href: AFFILIATE_URL, source: 'navbar_nav_sports_bet' },
    { label: 'Plinko', href: AFFILIATE_URL, source: 'navbar_nav_plinko' },
    { label: 'Hot Bonuses', href: AFFILIATE_URL, source: 'navbar_nav_hot_bonuses' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-white/95 backdrop-blur-xl border-b border-blue-200/50 shadow-sm' : 'bg-white/95 backdrop-blur-xl border-b border-blue-200/50 shadow-sm'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <a href="/" className="flex items-center group">
            <img
              alt="iPAY9 logo"
              className="h-12 w-auto transition-all duration-300"
              src="https://storage.readdy-site.link/project_files/4032d0ab-e29f-4bfa-a716-c411b87ebbce/8f4b55af-cb32-4845-bee7-78f5728b34da_fddf9c818e4964a58fcae.png"
            />
          </a>

          <nav className="hidden md:flex items-center gap-4 lg:gap-6">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                {...getAffiliateLinkProps(item.source, item.label)}
                className="relative text-xs lg:text-sm font-medium transition-all duration-300 whitespace-nowrap group text-slate-600 hover:text-blue-600"
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gradient-to-r from-blue-400 to-blue-300 transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2 lg:gap-3 shrink-0">
            <a href={AFFILIATE_URL} {...getAffiliateLinkProps('navbar_download_app', 'Download App')} className="btn-premium text-white text-xs lg:text-sm font-semibold px-4 py-2 lg:px-5 lg:py-2.5 rounded-lg whitespace-nowrap cursor-pointer animate-breathe">
              <span className="relative z-10">Download App</span>
            </a>
            <a href={AFFILIATE_URL} {...getAffiliateLinkProps('navbar_sign_up', 'Sign Up')} className="relative overflow-hidden text-xs lg:text-sm font-semibold px-4 py-2 lg:px-5 lg:py-2.5 rounded-lg whitespace-nowrap cursor-pointer transition-all duration-300 border border-blue-300 text-blue-600 hover:border-blue-500 hover:bg-blue-50">
              Sign Up
            </a>
          </div>

          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors text-slate-700"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/98 border-t border-blue-200/30 px-4 py-4 flex flex-col gap-1">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              {...affiliateLinkProps}
              className="text-sm font-medium text-slate-600 hover:text-blue-600 py-2.5 border-b border-blue-100/50 flex items-center gap-2"
              onClick={() => {
                trackRegisterClick(`${item.source}_mobile`, item.label);
                setMobileOpen(false);
              }}
            >
              {item.label}
            </a>
          ))}
          <div className="flex gap-3 pt-3">
            <a href={AFFILIATE_URL} {...getAffiliateLinkProps('navbar_mobile_download_app', 'Download App')} className="btn-premium text-white text-sm font-semibold px-4 py-2.5 rounded-lg whitespace-nowrap cursor-pointer flex-1 text-center">Download App</a>
            <a href={AFFILIATE_URL} {...getAffiliateLinkProps('navbar_mobile_sign_up', 'Sign Up')} className="text-sm font-semibold px-4 py-2.5 rounded-lg whitespace-nowrap cursor-pointer border border-blue-300 text-blue-600 flex-1 text-center">Sign Up</a>
          </div>
        </div>
      )}
    </header>
  );
}
